export default __webpack_public_path__ + "static/media/blueTrashIcon.134bb2cd.svg";